/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndividualInvestor } from './individual-investor';

export interface CompanyInvestor {
  readonly company_name: string;
  readonly organization_number: string;
  readonly giin: string;
  readonly utl: string;
  readonly address: string;
  readonly city: string;
  readonly post_code: string;
  readonly country: string;
  readonly amount: number;
  readonly representative: IndividualInvestor;
}
